import React from 'react';

import ArrayXQty from 'shared/components/parameters/ArrayXQuantity';
import ArrayYQty from 'shared/components/parameters/ArrayYQuantity';
import ArraySpacingXTV from 'shared/components/parameters/ArraySpacingXTV';
import ArraySpacingYTV from 'shared/components/parameters/ArraySpacingYTV';
import ArrayRails from 'shared/components/parameters/section_panelized/ArrayRails';

const NoPanelized = (props) => {
  const { parameters } = props;

  const { array_x, array_y } = parameters;

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <ArrayXQty {...props} />
        </div>
        <div className="col-md-6">
          <ArraySpacingXTV {...props} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <ArrayYQty {...props} />
        </div>
        <div className="col-md-6">
          <ArraySpacingYTV {...props} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <ArrayRails {...props} />
        </div>
      </div>

      <div className="">
        <div className="alert alert-info alert-panel-size">
          Panel Size {array_x} x {array_y}
        </div>
      </div>
    </div>
  );
};

export default NoPanelized;
